import "./Button.css";

function Button({id, label , className = "validate" , type = "button", disabled = false ,onClick, style = {}}) {
    const classNamePrefix = "button ";

    return (
        <button id={id} type={type} style={style} className={classNamePrefix + className} disabled={disabled} onClick={onClick}>{label}</button>
    )
}

export default Button;
